import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { mapStateToPropsWrapper, verificationProps } from '../../CaptureErreurs';
import Card from '../../Card';


const CardChoixModePaiement = ({
    PrlOk, ModePrl, setChoix, Manuel, GMC_PaiementParCheque_Visible
}) => (
    <Card Titre="Autres modes de paiement">
        <div className="d-flex flex-column align-items-center">
            {PrlOk ?
                <React.Fragment>
                    <Link to="/MesInformations/GererPrelevement" className="btn btn-primary mt-2" style={{ width: 300 }}>
                        {Manuel && (ModePrl.AutoExigibilite || ModePrl.AutoMensuel) ? 'Passer en prélèvement automatique' : 'Gérer mon prélèvement'}
                    </Link>
                </React.Fragment> : null}
            <button onClick={() => { setChoix('virement'); }} className="btn btn-secondary mt-2" style={{ width: 300 }}>
                Virement{PrlOk}
            </button>
            {GMC_PaiementParCheque_Visible ?
            <button onClick={() => { setChoix('cheque'); }} className="btn btn-secondary mt-2" style={{ width: 300 }}>
                Chèque
            </button> : null}
        </div>
    </Card>
);
CardChoixModePaiement.displayName = 'CardChoixModePaiement';
CardChoixModePaiement.requiredProps = [
    'ModePrl', // Modes de prélèvement accepté par le syndic
    'PrlOk', // Prélévement activé par la copro ou non
    'GMC_PaiementParCheque_Visible', // paiement pas cheque
];

function mapStateToProps({
    SynStore: {
        Syn: { ModePrl, GMC_PaiementParCheque_Visible },
    },
    CopStore: {
        Cop: { PrlOk },
    },
}) {
    return { ModePrl, PrlOk, GMC_PaiementParCheque_Visible };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardChoixModePaiement));



// WEBPACK FOOTER //
// ./src/components/MesInfos/Paiement/CardChoixAutrePaiement.js